//Load posts
export const fetchJournalsBegin = () => ({
    type: 'FETCH_JOURNALS_BEGIN'
});

export const fetchJournalsSuccess = journals => ({
    type: 'FETCH_JOURNALS_SUCCESS',
    payload: journals
});

export const fetchJournalsError = error => ({
    type: 'FETCH_JOURNALS_FAILURE',
    payload: { error }
});

export function fetchJournals() {
  return dispatch => {
    dispatch(fetchJournalsBegin());
    return fetch(process.env.REACT_APP_API_URL+process.env.REACT_APP_API_CUSTOM_PREFIX+'journals')
        .then(handleErrors)
        .then(response => response.json())
        .then(json => {
            dispatch(fetchJournalsSuccess(json));
        })
        .catch(error => dispatch(fetchJournalsError(error)));
    };
}
  
  // Handle HTTP errors since fetch won't.
  function handleErrors(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  }


// WEBPACK FOOTER //
// ./src/actions/journalActionCreators.js